export function buyerAdvisoryVacantLandDC924() {
return [   //2024 Release 2025-06-02 15:48:18
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 73.673,
 left: 53,
 width: 180,
 height: 27,
 }, 
{
   page: 0,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 218.28,
   width: 288.84,
   height: 10.20
}
,
{
   page: 0,
   name: "without right of transfer All rights reserved", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 95.52,
   width: 255.48,
   height: 10.20
}
,
{
   page: 0,
   name: "Text1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 172.801,
   left: 178.037,
   width: 356.837,
   height: 12.836
}
,
{
   page: 0,
   name: "Text2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.783,
   left: 179.346,
   width: 356.838,
   height: 12.836
}
,
{
   page: 0,
   name: "Text3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.31,
   left: 179.346,
   width: 356.838,
   height: 12.836
}
,
{
   page: 1,
   name: "undefined_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 218.28,
   width: 288.84,
   height: 10.20
}
,
{
   page: 1,
   name: "without right of transfer All rights reserved_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 95.52,
   width: 255.48,
   height: 10.20
}
,
{
   page: 2,
   name: "undefined_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 218.28,
   width: 288.84,
   height: 10.20
}
,
{
   page: 2,
   name: "without right of transfer All rights reserved_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 95.52,
   width: 255.48,
   height: 10.20
}
,
{
   page: 3,
   name: "undefined_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 218.28,
   width: 288.84,
   height: 10.20
}
,
{
   page: 3,
   name: "without right of transfer All rights reserved_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 95.52,
   width: 255.48,
   height: 10.20
}
,
{
   page: 4,
   name: "undefined_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.72,
   left: 218.28,
   width: 288.84,
   height: 10.20
}
,
{
   page: 4,
   name: "without right of transfer All rights reserved_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 95.52,
   width: 255.48,
   height: 10.20
}
,
{
   page: 5,
   name: "Transaction Coordinator Buyer understands that Broker may use an assistant or coordinator to", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 218.28,
   width: 288.84,
   height: 11.40
}
,
{
   page: 5,
   name: "signature Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 12,
   top: 310.091,
   left: 72.0,
   width: 136.789,
   height: 12.709
}
,
{
   page: 5,
   name: "date broker sign", 
   fontSize: 9,
   type: "date",
   top: 308.782,
   left: 222.218,
   width: 62.302,
   height: 14.018
}
,
{
   page: 5,
   name: "without right of transfer All rights reserved_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 744.36,
   left: 95.52,
   width: 255.48,
   height: 10.20
}
] }
